import { z } from 'zod';

const schema = z.object({
  dateFrom: z.date(),
  dateTo: z.date().optional(),
  duration: z.union([z.number(), z.null()]).optional(),
});

export default schema;
